<template>
<div class="schedule-vue-sample">
 <div class="row">
  <div class="col-lg-10 control-section">
   <div class="content-wrapper">
    <ejs-schedule
      id='Schedule' 
      ref="ScheduleObj"
      :height='height' 
      :width='width'  
      :cssClass='cssClass'
      :eventSettings='eventSettings'
      :group='group'
      :currentView='currentView' 
      :showQuickInfo="showQuickInfo"
      :popupOpen='onPopupOpen'
      :popupClose='onPopupClose'
      :editorTemplate='editorTemplate' 
      :views='views'
      :actionBegin="onActionBegin"
      :actionComplete="onActionComplete"
      :actionFailure="onActionFailure"
      :calendarCollections='employeeDataSource'
      :selectedDate='selectedDate'
      :dataBound="onDataBound"
      :eventRendered="OnEventRendered"
      :dragStart="onDragStart"
      :resizeStart="onResizeStart"
      :created="onCreated"
      :timeScale="timeScale"
      :timezone="timezone"
      :locale="locale"
      >
      <e-views>
        <e-view option="Day" :eventTemplate="dayTemplate"></e-view>
        <e-view option="Week" :eventTemplate="weekTemplate"></e-view>
        <e-view option="WorkWeek" :eventTemplate="workWeekTemplate"></e-view>
        <e-view option="Month" :eventTemplate="monthTemplate"></e-view>
      </e-views>
      <e-resources>
        <e-resource 
          field='employeeCode' 
          :title="$tc('Shared.Employee',2)"
          name='Employee' 
          :dataSource='employeeDataSource'
          textField='employeeName' 
          idField='employeeCode' 
          groupIDField='GroupId' 
          colorField='Color'
          allowMultiple="true">
        </e-resource>
      </e-resources>
    </ejs-schedule>
   </div>
  </div>
    <div class="col-lg-2 property-section HideFilter">
        <div class="textlabel" :data-label="this.$tc('Shared.Employee',2)">
         <ejs-multiselect 
           id='multiselect' 
           :dataSource='employeeDataSource' 
           :fields='fieldsEmployee' 
           :allowCustomValue='allowCustomValue'
           :placeholder="$t('schedule_sample.sEmployee')"
           :change='onChangeResource'
           :value='employeeValue'>
         </ejs-multiselect>
      </div>
      <div class="textlabel" :data-label="this.$t('employeeType.EmplTypeTitle')">
         <ejs-multiselect 
           id='multiselect' 
           :dataSource='employeeTypesDataSource' 
           :fields='fieldsEmployeeTypes' 
           :placeholder="this.$t('employeeType.EmplTypeTitle')"
           :change='onChangeEmployeeTypes'>
         </ejs-multiselect>
      </div>
      <MdLookup
        v-bind:Label="$tc('Shared.Patient',2)"
        v-bind:ModelCode="patientCode"
        v-bind:ModelDescription="patientName"
        v-bind:RefCode="'patientcode'"
        v-bind:Api="'Patients'"
        v-bind:FieldCode="'patientcode'"
        v-bind:FieldDescription="'firstname'"
        :SearchTitle="$tc('Shared.Patient',2)"
        :GetValues="getValues"
        :InvalidFeedback="$t('Msg.InvalidCode')"
        :SearchFieldCode="'PatientCode'"
        :AuxFields="AuxFields"
        :Placeholder="$t('schedule_sample.sPatient')"
        :FieldsDate="fieldsDate"
        v-bind:Fields="BaseFields"
      />
        <MdSelect
            v-bind:Label="$t('Shared.Status')"
            v-bind:Options="StatusDataSource"
            v-bind:FieldDescription="'name'"
            v-bind:FieldCode="'value'"           
            v-bind:Placeholder="$t('schedule_sample.sStatus')"
            v-bind:Model="StatusModel"               
            v-bind:Multiple="false"                   
            :Input="onChangeStatus"            
          />

        <div v-if="useBranchLocations" class="textlabel" :data-label="this.$t('schedulerDB.AppointmentLocation')">
         <ejs-multiselect 
           id='multiselect' 
           :dataSource='AppointmentLocationList' 
           :fields='fieldsLocation' 
           :placeholder="this.$t('schedule_sample.sLocation')"
           :change='ChangeDropDownAppointmentLocation'>
         </ejs-multiselect>
      </div>

      <ejs-dialog
        ref="alertDlg"
        id="alertDialog"
        :header="confirmHeader"
        width="400px"
        isModal="true"
        showCloseIcon="true"
        target="#Schedule"
        v-bind:visible="false"
        :buttons="dlgButtons"
      >
      <table style='width:371px' id ='poschange'>
        <tr>
          <td><ejs-radiobutton id='radio1' checked=true :label="$t('schedule_sample.tEvent')" value='ThisEvent' name='eventSel' :change='changeRecurrenceType'></ejs-radiobutton></td>
        </tr>
        <tr>
          <td><ejs-radiobutton id='radio2' :label="$t('schedule_sample.ThFallowEvent')" value='ThisAndFollowing' name='eventSel' :change='changeRecurrenceType'></ejs-radiobutton></td>
        </tr>
        <tr>
          <td><ejs-radiobutton id='radio3' :label="$t('schedule_sample.aEvents')" value='AllEvents' name='eventSel' :change='changeRecurrenceType'></ejs-radiobutton></td>
        </tr>
      </table>
      </ejs-dialog>
      <SchedulerDailyRep v-if="isReportVisible" 
        :closeWindow="closeParamRepWindow"
        :startDate="startDate"
        :useBranchLocations="useBranchLocations"
      />
      
    </div>
 </div>
  <div class="panel-scheduler" style="position: relative !important;">
    {{tzDisplayName}}
  </div>

  <ScheduleNotify v-if="this.showNotifyDlg"
    v-bind:onClose="closeNotifyDlg"
    v-bind:activityId="activityId"
    v-bind:employeeCode="notifyEmployeeCode"
    v-bind:patientCode="notifyPatientCode"
    v-bind:sysUser="notifySysUser"
    v-bind:module="'SCHEDULER'"
    v-bind:showIn="'SCHEDULER'"
  ></ScheduleNotify>

</div>
</template>
<script>
import Vue from 'vue';
import { SchedulePlugin, Day, Week, WorkWeek, Month, Resize, DragAndDrop } from "@syncfusion/ej2-vue-schedule";
Vue.use(SchedulePlugin);
import { DropDownList } from '@syncfusion/ej2-dropdowns';
import { DateTimePicker } from '@syncfusion/ej2-calendars';
import { L10n, Internationalization } from '@syncfusion/ej2-base';
import { TextBox } from '@syncfusion/ej2-inputs';
import { ColorPicker } from '@syncfusion/ej2-inputs';
import { CheckBox, Button } from '@syncfusion/ej2-buttons';
import editortemplate from "./schedule-editor.vue";
import { Query, DataManager, Predicate/*, UrlAdaptor*/ } from '@syncfusion/ej2-data';
import { MultiSelectComponent, MultiSelectPlugin } from '@syncfusion/ej2-vue-dropdowns';
import { ButtonPlugin, RadioButtonPlugin } from "@syncfusion/ej2-vue-buttons";
import { DialogPlugin } from "@syncfusion/ej2-vue-popups";
import skd from '@/lang/sched-es.json'
import skdar from '@/lang/sched-ar.json'

import { loadCldr} from '@syncfusion/ej2-base';
import numberDataES from '@syncfusion/ej2-cldr-data/main/es/numbers.json';
import timeZoneDataES from '@syncfusion/ej2-cldr-data/main/es/timeZoneNames.json';
import gregorianES from '@syncfusion/ej2-cldr-data/main/es/ca-gregorian.json';
import numberingSystemES from '@syncfusion/ej2-cldr-data/supplemental/numberingSystems.json';
import ScheduleCustomAdaptor from './schedule_custom_adaptor'

import numberDataAR from '@syncfusion/ej2-cldr-data/main/ar/numbers.json';
import timeZoneDataAR from '@syncfusion/ej2-cldr-data/main/ar/timeZoneNames.json';
import gregorianAR from '@syncfusion/ej2-cldr-data/main/ar/ca-gregorian.json';


Vue.component(MultiSelectPlugin.name, MultiSelectComponent);
Vue.use(ButtonPlugin);
Vue.use(DialogPlugin);
Vue.use(RadioButtonPlugin);

var resourceHeaderVue = Vue.component("resource-headerTemplate", {
        template: '<div className="template-wrap"><div class="employee-category"><div class="employee-name">' +
                  '{{getEmployeeName(data)}}</div><div class="employee-designation">{{getEmployeeDesignation(data)}}</div></div></div>',
        data() {
            return {
                data: {}
            };
        },
        methods: {
            getEmployeeName: function (data) {
                let value = JSON.parse(JSON.stringify(data));
                return (value.resourceData) ? value.resourceData[value.resource.textField] : value.resourceName;
            },
            getEmployeeDesignation: function (data) {
                let value = JSON.parse(JSON.stringify(data));
                return value.resourceData.Designation;
            }
        }
    });

    var lang = localStorage.language;
    
    switch(lang) {
        case 'es':
            L10n.load(skd);
            loadCldr(numberDataES, timeZoneDataES, gregorianES, numberingSystemES);
            break;
        case 'ar':
            L10n.load(skdar);
            loadCldr(numberDataAR, timeZoneDataAR, gregorianAR, numberingSystemES);
            break;
        default:
          L10n.load({
            'en-US': {
                'schedule': {
                    'saveButton': 'SAVE',
                    'cancelButton': 'CLOSE',
                    'deleteButton': 'REMOVE',
                    // 'newEvent': `Appointment Editor`,
                    // 'editEvent': `Appointment Editor`,
                },
              }
          });
          break;
        }
    
    
    var instance = new Internationalization();
    var dayTempVue = Vue.component("dayTemp", {
        template: '<div class="template-wrapper" v-if="!data.isBlock">'+
        '<div class="subject" :id="data.id" style="color:white; cursor:pointer">{{setSubject(data)}}</div>'+       
        '<b-tooltip  :target="data.id" triggers="hover">'+
          '<h6 class="eventHintHeader">{{$t("schedule_sample.appoDetails")}}</h6>'+
          '<div class="eventHint">'+
          '<b-icon icon="calendar3"></b-icon> {{getStartTime(data)}}<br>'+
          '<b-icon icon="calendar3"></b-icon> {{getEndTime(data)}}<br>'+
          '<b-icon icon="chat-right-dots"></b-icon> {{getAppointment(data)}}<br>'+
          '<b-icon icon="calendar-check"></b-icon> {{getConfirmed(data)}}<br>'+
          '<b-icon icon="person"></b-icon> {{getPatientName(data)}}<br>'+  
          '<b-icon icon="chat-right-dots" v-if="data.notes"></b-icon>'+
          '{{getNotes(data)}}'+
          '</div>'+
          '<i>{{getEmployeeName(data)}}</i>'+

        '</b-tooltip></div>',
        methods: {
           setSubject: function (data) {
            let oldString = data.subject;
            let substrings = ["- CANCELLED", "- CONFIRMED", "- SHOWED UP"];
            let newString = data.appointmentTypeName;

            let result = oldString;
            let found = false;

            substrings.forEach(substring => {
              let pos = oldString.indexOf(substring);

              if (pos !== -1) {
                result = result.slice(0, pos) + ' - ' + newString  + ' ' + result.slice(pos);
                found = true
              }
            });
            return found ? result : newString ? oldString + ' - ' + newString : oldString
           },

           getStartTime: function (data) {
              //return `${instance.formatDate(data.startTime, { skeleton: 'yMd' })} ${instance.formatDate(data.startTime, { skeleton: 'hm' })}`;
               return instance.formatDate(data.startTime, { format: Utils.getSchedulerDateTimeFormat() });
           },
           getEndTime: function (data) {
             // return `${instance.formatDate(data.endTime, { skeleton: 'yMd' })} ${instance.formatDate(data.endTime, { skeleton: 'hm' })}`;
              return instance.formatDate(data.endTime, { format: Utils.getSchedulerDateTimeFormat() });
           },
           getAppointment: function (data) {
             return data.appointmentTypeName
           },
           getConfirmed: function (data) {
             if (data.patientConfirmed) {
               if (data.patientShowedUp) {
                 return this.$t('schedule_sample.showedUp')
               }
               else if (data.reason && data.reason.length > 0) {
                 return this.$t('schedule_sample.canceled')
               }
               else {
                 return this.$t('schedule_sample.confirmed')
               }
             } else {
               if (data.patientShowedUp) {
                 return this.$t('schedule_sample.showedUp')
               }
               else if (data.reason && data.reason.length > 0) {
                 return this.$t('schedule_sample.canceled')
               }
               else {
                 return this.$t('schedule_sample.new')
               }
             }
           },
           getPatientName: function (data) {
             return data.patientName
           },
           getEmployeeName: function (data) {
             return data.employeeName
           },
           getNotes: function (data) {
            if (data.notes)
              return data.notes
            else 
              return ''
           }
        }
    });
    var weekTempVue = Vue.component("weekyTemp", {
        template: '<div class="template-wrapper" v-if="!data.isBlock">'+
        '<div class="subject" :id="data.id" style="color:white">{{data.subject}} </div>'+
        '<b-tooltip  :target="data.id" triggers="hover">'+
          '<h6 class="eventHintHeader">{{$t("schedule_sample.appoDetails")}}</h6>'+
          '<div class="eventHint">'+
          '<b-icon icon="calendar3"></b-icon> {{getStartTime(data)}}<br>'+
          '<b-icon icon="calendar3"></b-icon> {{getEndTime(data)}}<br>'+
          '<b-icon icon="chat-right-dots"></b-icon> {{getAppointment(data)}}<br>'+
          '<b-icon icon="calendar-check"></b-icon> {{getConfirmed(data)}}<br>'+
          '<b-icon icon="person"></b-icon> {{getPatientName(data)}}<br>'+
          '<b-icon icon="chat-right-dots" v-if="data.notes"></b-icon>'+
          '{{getNotes(data)}}'+
          '</div>'+
          '<i>{{getEmployeeName(data)}}</i>'+

        '</b-tooltip></div>',
        methods: {
           getStartTime: function (data) {
             // return `${instance.formatDate(data.startTime, { skeleton: 'yMd' })} ${instance.formatDate(data.startTime, { skeleton: 'hm' })}`;
             return instance.formatDate(data.startTime, { format: Utils.getSchedulerDateTimeFormat() });
           },
           getEndTime: function (data) {
            //  return `${instance.formatDate(data.endTime, { skeleton: 'yMd' })} ${instance.formatDate(data.endTime, { skeleton: 'hm' })}`;
            return instance.formatDate(data.endTime, { format: Utils.getSchedulerDateTimeFormat() });
           },
           getAppointment: function (data) {
             return data.appointmentTypeName
           },
           getConfirmed: function (data) {
             if (data.patientConfirmed) {
               if (data.patientShowedUp) {
                 return this.$t('schedule_sample.showedUp')
               }
               else if (data.reason && data.reason.length > 0) {
                 return this.$t('schedule_sample.canceled')
               }
               else {
                 return this.$t('schedule_sample.confirmed')
               }
             } else {
               if (data.patientShowedUp) {
                 return this.$t('schedule_sample.showedUp')
               }
               else if (data.reason && data.reason.length > 0) {
                 return this.$t('schedule_sample.canceled')
               }
               else {
                 return this.$t('schedule_sample.new')
               }
             }
           },
           getPatientName: function (data) {
             return data.patientName
           },
           getEmployeeName: function (data) {
             return data.employeeName
           },
           getNotes: function (data) {
            if (data.notes)
              return data.notes
            else 
              return ''
           }
        }
    });
    var workWeekTempVue = Vue.component("workWeekyTemp", {
        template: '<div class="template-wrapper" v-if="!data.isBlock">'+
        '<div class="subject" :id="data.id" style="color:white">{{data.subject}} </div>'+
        '<b-tooltip  :target="data.id" triggers="hover">'+
          '<h6 class="eventHintHeader">{{$t("schedule_sample.appoDetails")}}</h6>'+
          '<div class="eventHint">'+
          '<b-icon icon="calendar3"></b-icon> {{getStartTime(data)}}<br>'+
          '<b-icon icon="calendar3"></b-icon> {{getEndTime(data)}}<br>'+
          '<b-icon icon="chat-right-dots"></b-icon> {{getAppointment(data)}}<br>'+
          '<b-icon icon="calendar-check"></b-icon> {{getConfirmed(data)}}<br>'+
          '<b-icon icon="person"></b-icon> {{getPatientName(data)}}<br>'+ 
          '<b-icon icon="chat-right-dots" v-if="data.notes"></b-icon>'+
          '{{getNotes(data)}}'+
          '</div>'+
          '<i>{{getEmployeeName(data)}}</i>'+

        '</b-tooltip></div>',
        methods: {
           getStartTime: function (data) {
             // return `${instance.formatDate(data.startTime, { skeleton: 'yMd' })} ${instance.formatDate(data.startTime, { skeleton: 'hm' })}`;
              return instance.formatDate(data.startTime, { format: Utils.getSchedulerDateTimeFormat() });
           },
           getEndTime: function (data) {
              //return `${instance.formatDate(data.endTime, { skeleton: 'yMd' })} ${instance.formatDate(data.endTime, { skeleton: 'hm' })}`;
               return instance.formatDate(data.endTime, { format: Utils.getSchedulerDateTimeFormat() });
           },
           getAppointment: function (data) {
             return data.appointmentTypeName
           },
           getConfirmed: function (data) {
             if (data.patientConfirmed) {
               if (data.patientShowedUp) {
                 return this.$t('schedule_sample.showedUp')
               }
               else if (data.reason && data.reason.length > 0) {
                 return this.$t('schedule_sample.canceled')
               }
               else {
                 return this.$t('schedule_sample.confirmed')
               }
             } else {
               if (data.patientShowedUp) {
                 return this.$t('schedule_sample.showedUp')
               }
               else if (data.reason && data.reason.length > 0) {
                 return this.$t('schedule_sample.canceled')
               }
               else {
                 return this.$t('schedule_sample.new')
               }
             }
           },
           getPatientName: function (data) {
             return data.patientName
           },
           getEmployeeName: function (data) {
             return data.employeeName
           },
           getNotes: function (data) {
            if (data.notes)
              return data.notes
            else 
              return ''
           }
        }
    });
    var monthTempVue = Vue.component("monthTemp", {
        template: '<div class="template-wrapper" v-if="!data.isBlock">'+
        '<div class="subject" :id="data.id" style="color:white">{{data.subject}} </div>'+
        '<b-tooltip  :target="data.id" triggers="hover">'+
          '<h6 class="eventHintHeader">{{$t("schedule_sample.appoDetails")}}</h6>'+
          '<div class="eventHint">'+
          '<b-icon icon="calendar3"></b-icon> {{getStartTime(data)}}<br>'+
          '<b-icon icon="calendar3"></b-icon> {{getEndTime(data)}}<br>'+
          '<b-icon icon="chat-right-dots"></b-icon> {{getAppointment(data)}}<br>'+
          '<b-icon icon="calendar-check"></b-icon> {{getConfirmed(data)}}<br>'+
          '<b-icon icon="person"></b-icon> {{getPatientName(data)}}<br>'+
          '<b-icon icon="chat-right-dots" v-if="data.notes"></b-icon>'+
          '{{getNotes(data)}}'+
          '</div>'+
          '<i>{{getEmployeeName(data)}}</i><br><br>'+
          
        '</b-tooltip></div>',
        methods: {
           getStartTime: function (data) {
              //return `${instance.formatDate(data.startTime, { skeleton: 'yMd' })} ${instance.formatDate(data.startTime, { skeleton: 'hm' })}`;
              return instance.formatDate(data.startTime, { format: Utils.getSchedulerDateTimeFormat() });
           },
           getEndTime: function (data) {
             // return `${instance.formatDate(data.endTime, { skeleton: 'yMd' })} ${instance.formatDate(data.endTime, { skeleton: 'hm' })}`;
             return instance.formatDate(data.endTime, { format: Utils.getSchedulerDateTimeFormat() });
           },
           getAppointment: function (data) {
             return data.appointmentTypeName
           },
           getConfirmed: function (data) {
             if (data.patientConfirmed) {
               if (data.patientShowedUp) {
                 return this.$t('schedule_sample.showedUp')
               }
               else if (data.reason && data.reason.length > 0) {
                 return this.$t('schedule_sample.canceled')
               }
               else {
                 return this.$t('schedule_sample.confirmed')
               }
             } else {
               if (data.patientShowedUp) {
                 return this.$t('schedule_sample.showedUp')
               }
               else if (data.reason && data.reason.length > 0) {
                 return this.$t('schedule_sample.canceled')
               }
               else {
                 return this.$t('schedule_sample.new')
               }
             }
           },
           getPatientName: function (data) {
             return data.patientName
           },
           getEmployeeName: function (data) {
             return data.employeeName
           },
           getNotes: function (data) {
            if (data.notes)
              return data.notes
            else 
              return ''
           }
        }
    });
import CalendarResourcesService from '@/services/calendarresources.service'
import ShowMessage from '@/components/messages/ShowMessage.js'
import DBFunctions from '@/common/DBFunctions.js'
import StorageService from '@/services/storage.service'
import ApiService from '@/services/api.service'
import EmployeeTypesService from '@/services/employeetypes.service'
import AppointmentTypes from '@/services/appointmenttypes.service'
import PatientService from '@/services/patient.service'
import ReasonService from '@/services/reason.service'
import SchedulerOptionsService from '@/services/schedulersoptions.service'
import UserAssignmentToCalResService from '@/services/userassignmenttocalres.service'
import EnumService from '@/services/enum.service'
import GlobalService from '@/services/global.service'
import ClinicalService from '@/services/clinical.service'
import Utils from "@/common/utils";
import Permission from '@/common/Permission'
import BranchLocation from '@/services/branchlocation.service'
import ProviderService from '@/services/provider.service'

export default Vue.extend({
    name: 'Schedule',
    mixins: [ ShowMessage,DBFunctions,Permission ],
    data: function () {
    return {
      dayTemplate: function () {
        return {
          template: dayTempVue
        };
      },
      weekTemplate: function () {
        return {
          template: weekTempVue
        };
      },
      workWeekTemplate: function () {
        return {
          template: workWeekTempVue
        };
      },
      monthTemplate: function () {
        return {
          template: monthTempVue
        };
      },
      //Menu : this.$store.state.leftMenu,
      //permission: [],
      patientCode: '',
      ShowCancelAppointment:false,
      patientName: '',
      StatusModel:{value:"All",name:this.$t('Shared.All')},
      AppointmentLocationVmodel:{},
      AuxFields:['lastname'],
      currentView: 'Day',
      cssClass: 'block-events',
      showQuickInfo: false,
      height: 'calc(100vh - 110px)',
      width: '100%',
      fieldsEmployee : { text: 'employeeName', value: 'employeeCode' },
      fieldsStatus:{text: 'name', value: 'value'},
      fieldsEmployeeTypes : { text: 'description', value: 'code' },
      fieldsLocation : { text: 'description', value: 'code' },
      allowCustomValue : true,
      views: ['Day', 'Week', 'WorkWeek', 'Month'],
      weekNumberTemplate: '<div><button id="view_name"></button></div>',
      buttonRefreshTemplate: '<button id="button_view"></button></div>',
      buttonPrintTemplate: '<button id="button_print"></button></div>',
      OptionsRightMenu:{
            visible:true,
            ItemsList:[],
            btnvisible:true,
            itemdisabled: false,          
      },
      editorTemplate: function () {
        return { template: editortemplate }
      },
      schedulerfields: {
          // id: 'id',
          subject: { name: 'subject' },
          location: { name: 'location' },
          description: { name: 'notes' },
          startTime: { name: 'startTime' },
          endTime: { name: 'endTime' },
          backgroundColor: { name: 'backgroundColor' },
      },
      selectedDate: new Date(),
      eventSettings: this.getEventsSettings(),
      viewType: true,
      group: { enableCompactView: true, resources: ['Employee'] },
      employeeDataSource: [],
      StatusDataSource:EnumService.SchedulerStatus,
      employeeTypesDataSource: [],
      AppointmentLocationList: [],
      facilityDataSource: [],
      reasonDataSource: [],
      useBranchLocations: false,
      enforceLocation: null,
      parameter:{
        EmployeeTypeList:[],
      },
      fieldsDate:['dob'],
      resourceHeaderTemplate: function () {
        return { template: resourceHeaderVue }
      },
      defaultAppointmentColor: '#0A64FF',
      defaultBlockingColor: '#C7C7C7',

      paramsUserAssignment: {
        UserID: ''
      },
      flag:true,
      isUserAssignmentToCalRes: false,
      timeScale: {
        enable: true,
        interval: 60,
        slotCount: 4
      },
      timezone: undefined,
      tzDisplayName: null,
      isCustomSave: false,
      eventData: [],
      fieldsToValidate: {
        patientCode: '',
        startTime: '',
        endTime: '',
        employeeCode: '',
        appointmentTypeCode: '',
        recurrence: '' 
      },
      eventAction: '',
      applyActionTo: '',
      confirmHeader: '',
      isReportVisible: false,
      startDate: null,
      showNotifyDlg: false,
      activityId: null,
      notifyEmployeeCode: null,
      notifyPatientCode: null,
      notifySysUser: StorageService.getUserId(),
      dlgButtons: [
        {
          buttonModel: { content: this.$t('Shared.Save'), isPrimary: true },
          click: () => {
            const scheduleObj = document.querySelector(".e-schedule").ej2_instances[0];
            const dialogObj = document.querySelector("#alertDialog").ej2_instances[0];          
            if (this.eventAction === 'eventChange') {
              this.isCustomSave = true;
              scheduleObj.eventSettings.query.params[2].value = this.applyActionTo
              scheduleObj.saveEvent(this.eventData);
            }
            if (this.eventAction === 'eventRemove') {
              scheduleObj.eventSettings.query.params[2].value = this.applyActionTo
              scheduleObj.deleteEvent(this.eventData);
            }
            dialogObj.hide();
          },
        },
        {
          buttonModel: { content: this.$t('Shared.Close') },
          click: () => {
            const dialogObj = document.querySelector("#alertDialog").ej2_instances[0];
            dialogObj.hide();
          },
        },
      ],
      locale: localStorage.language, // Initial locale (can be overridden later)
      employeeValue: [],
      employeeTypeList: [], 
      BaseFields:[
        { key: 'firstname', sortable: true, label: this.$t('Shared.FirstName') },
        { key: 'lastname', sortable: true, label: this.$t('Shared.LastName')},
        { key: 'patientcode', sortable: true, label: this.$t('Shared.Code')},
        { key: 'cellPhone', sortable: true, label: this.$t('Shared.CellPhone')},
        { key: 'address1', sortable: true, label: this.$t('Shared.Address1')},
        { key: 'city', sortable: true, label: this.$t('Shared.City')},
        { key: 'state', sortable: true, label: this.$t('Shared.State')},
        { key: 'country', sortable: true, label: this.$t('Shared.Country')},
        { key: 'zip', sortable: true, label: this.$t('Shared.Zip')}
      ]

    }
  },
    provide: {
      schedule: [Day, Week, WorkWeek, Month, Resize, DragAndDrop]
    },

    methods: {

      closeNotifyDlg() {
        this.showNotifyDlg = false
      },

      adjust(color, amount) {
        return '#' + color.replace(/^#/, '').replace(/../g, color => ('0'+Math.min(255, Math.max(0, parseInt(color, 16) + amount)).toString(16)).substr(-2));
      },

      changeRecurrenceType(args) {
        this.applyActionTo = args.value
      },

      OnEventRendered(args) {
        if(args.data.backgroundColor === null || args.data.backgroundColor === undefined) {
          if (args.data.isBlock){
            args.element.style.backgroundColor = this.defaultBlockingColor
          } else {
            let dColor = this.adjust(this.defaultAppointmentColor,-50);
            args.element.style.backgroundImage = "linear-gradient(0deg, "+dColor+", "+this.defaultAppointmentColor+")";
          }

        } else {
          let dColor = this.adjust(args.data.backgroundColor,-50);
          args.element.style.backgroundImage = "linear-gradient(0deg, "+dColor+", "+args.data.backgroundColor+")";
        }
      },

      onChangeView(args) {
        let scheduleObj = document.getElementById("Schedule").ej2_instances[0];
        if(args.value == this.$t('schedule_sample.bCalendar')) {
          scheduleObj.group.resources = []
          this.viewType = false
        } else {
          scheduleObj.group.resources = ['Employee']
          this.viewType = true
        }
      },

      onActionFailure(args) {
        this.$emit('load', false);
        this.$refs.ScheduleObj.refreshEvents()
        if(args.error && args.error.length > 0 && args.error[0].error.status === 400) {
          let msgText = args.error[0].error.responseText.split(':')
          msgText = msgText[1].replaceAll('"', '').replaceAll('}', '');
          this.showMessage(this.$tc('Msg.Error'),msgText,"error");
        } else if (args.error && args.error.error && args.error.error.status === 401) {
          this.$router.go()
        }
      },

      onActionComplete(args) {
        let root = this 
        let scheduleObj = document.getElementById('Schedule'); 
        let dropdowns = scheduleObj.querySelector('#view_name');
        let button = scheduleObj.querySelector('#button_view');
        let buttonPrint = scheduleObj.querySelector('#button_print');
        if (args.requestType === "toolBarItemRendered") { 
          let dropDownListObject = new DropDownList({
            value: this.$t('schedule_sample.bResource'),
            dataSource: [this.$t('schedule_sample.bResource'), this.$t('schedule_sample.bCalendar')],
            change: this.onChangeView.bind(this) 
          });
          dropDownListObject.appendTo(dropdowns);

          let buttonObjectRefresh = new Button({
            cssClass: 'e-tbar-btn e-tbtn-txt e-control e-btn',
            iconCss:'e-icons e-refresh-icon'
          });
          buttonObjectRefresh.appendTo(button);
          document.getElementById('button_view').setAttribute('title', this.$t('schedule_sample.Refresh'))
          buttonObjectRefresh.element.addEventListener('click', function (args) {
            let scheduleObj = args.view.document.getElementById("Schedule").ej2_instances[0]
            scheduleObj.refreshEvents()
            root.getUserAssignmentToCalRes()
          });

          let buttonObjectPrint = new Button({
            cssClass: 'e-tbar-btn e-tbtn-txt e-control e-btn',
            iconCss:'e-icons e-print-icon'
          });
          buttonObjectPrint.appendTo(buttonPrint);
          document.getElementById('button_print').setAttribute('title', this.$t('schedule_sample.Print'))
          buttonObjectPrint.element.addEventListener('click', function (args) {
            let scheduleObj = args.view.document.getElementById("Schedule").ej2_instances[0]
            root.startDate = scheduleObj.selectedDate
            root.showReport()
          });
        } 
        
        if(args.requestType === 'eventCreated' || args.requestType === 'eventChanged' || 
           args.requestType === 'eventRemoved') {
          this.$emit('load', false);
        }

        let scheduleObj1 = this.$refs.ScheduleObj;
        scheduleObj1.eventSettings.query.params[3].value = this.StatusModel.value;
      },
      
      onActionBegin: function (args) {
        const scheduleObj = document.querySelector(".e-schedule").ej2_instances[0];        
        if (args.requestType === 'toolbarItemRendering') {
          let scheduleSeperator = {
            align: "Right",
            cssClass: 'e-schedule-seperator',
            type: "Separator"
          }
          let byResourceItem = {
            align: 'Right', 
            template: this.weekNumberTemplate, 
            type: 'Input' 
          };
          let buttonItem = {
            align: 'Right', 
            template: this.buttonRefreshTemplate, 
            type: 'Input' 
          };
          let buttonPrint = {
            align: 'Right', 
            template: this.buttonPrintTemplate, 
            type: 'Input' 
          };
          args.items.push(scheduleSeperator);
          args.items.push(byResourceItem);
          args.items.push(buttonItem);
          args.items.push(buttonPrint);
        }

        
        if(args.requestType === 'eventCreate' || args.requestType === 'eventChange' || 
           args.requestType === 'eventRemove') {
           this.$emit('load', true);
        }

        if (args.requestType === "eventCreate") {
          args.data[0].id = '1'
        }
        
        // Add the RecurrenceRule property if missing, getting its value from recurrence
        if (args.changedRecords && args.changedRecords[0]) {
          if (!args.changedRecords[0].RecurrenceRule && args.changedRecords[0].recurrence) {
            args.changedRecords[0].RecurrenceRule = args.changedRecords[0].recurrence;
          }
        }

        if (!this.isCustomSave && args.requestType === "eventChange" && this.fieldsToValidate.recurrence && 
          args.data.recurrence && this.fieldsToValidate.recurrence !== args.data.recurrence) {
            args.cancel = true;
            this.isCustomSave = true
            scheduleObj.eventSettings.query.params[2].value = 'ThisAndFollowing'
            scheduleObj.saveEvent(args.changedRecords[0]);
            this.$emit('load', false);
        }
        else if (!this.isCustomSave && args.requestType === "eventChange" && this.isModifiedFields(args.changedRecords[0])) {
          args.cancel = true;
          this.applyActionTo = 'ThisEvent'
          this.eventAction = "eventChange"
          this.confirmHeader = this.$t('schedule_sample.editAppoReMsg')
          this.eventData = args.changedRecords[0]

          const dialogObj = document.querySelector("#alertDialog").ej2_instances[0];
          const radio = document.querySelector("#radio1").ej2_instances[0];
          let dlgButtons = dialogObj.getButtons()
        
          radio.checked = true;
          dlgButtons[0].content = this.$t('Shared.Save')
          
          if (args.data.parent) {
            this.eventData.id = args.data.parent.id
          }
          this.$emit('load', false);
          dialogObj.show();
        } 
        else if (!this.isCustomSave && args.requestType === "eventChange" && args.changedRecords[0].recurrence) {
          args.cancel = true;
          this.isCustomSave = true;
          scheduleObj.eventSettings.query.params[2].value = 'ThisEvent'
          this.eventData = args.changedRecords[0]
          if (args.data.parent) {
            this.eventData.id = args.data.parent.id
          }
          scheduleObj.saveEvent(this.eventData);
        }
      },

      setInitialValues(data) {
        this.fieldsToValidate.patientCode = data.patientCode
        this.fieldsToValidate.startTime = data.startTime
        this.fieldsToValidate.endTime = data.endTime
        this.fieldsToValidate.employeeCode = data.employeeCode
        this.fieldsToValidate.appointmentTypeCode = data.type
        this.fieldsToValidate.recurrence = data.recurrence
        this.isCustomSave = false;
      },

      onDragStart(args) {
        this.isCustomSave = false;
        this.setInitialValues(args.data)
      },

      onResizeStart(args) {
        this.setInitialValues(args.data)
      },

      changeResources(resources) {
        let resourcePredicate;
        let scheduleObj = this.$refs.ScheduleObj
        for (var a = 0; a < resources.length; a++) { 
          var predicate = new Predicate("employeeCode", "equal", resources[a]); 
          resourcePredicate = resourcePredicate ? resourcePredicate.or(predicate) : predicate; 
        } 
        let resourceQuery = resourcePredicate ? new Query().where(resourcePredicate) : new Query();        
        scheduleObj.ej2Instances.resources[0].query = resourceQuery
        scheduleObj.eventSettings.query.params[1].value = resources ? resources : undefined;
      },

      applyFilters(employeeList, employeeTypeList) {
        let employeeLst = []

        if (employeeList.length > 0 && employeeTypeList.length > 0)
          employeeLst = employeeList.concat(employeeTypeList)
        else if (employeeList.length == 0 && employeeTypeList.length > 0)
          employeeLst = employeeTypeList
        else if (employeeList.length > 0 && employeeTypeList.length == 0)
          employeeLst = employeeList

        this.changeResources(employeeLst)
      },

      onChangeResource: function (args) {
        this.employeeValue = args.value

        this.applyFilters(this.employeeValue, this.employeeTypeList)

   /*      if (args.value.length > 0) {
          if (this.employeeTypeList.length > 0) {
            employeeList.push(...this.employeeTypeList)
            this.changeResources(employeeList)
          }
          else
            this.changeResources(this.employeeValue)
        } else if (this.employeeValue.length > 0) {
          this.changeResources(this.employeeValue)
        }    */      
      },

      onChangeStatus: function (e) {       
        this.StatusModel = e !== null && e !== "" ? e : {value:"All",name:this.$t('Shared.All')};
        let scheduleObj = this.$refs.ScheduleObj;
        scheduleObj.eventSettings.query.params[3].value = this.StatusModel.value;
        scheduleObj.refreshEvents(); 
      },

      async onChangeEmployeeTypes (args) {
        let l = args.value.length;
        var EmployeeTypeList = [];
        if(l>0){
          let i = 0;
          args.value.forEach(function(e) {   
            if(i<l-1){
              EmployeeTypeList += e+",";
            }else{
              EmployeeTypeList += e;
            }
            i++;                    
          });
        }
        await this.getCalendarResByEmployeeType(EmployeeTypeList)
      },

      ChangeDropDownAppointmentLocation(e) {
        this.AppointmentLocationVmodel = e !== null && e !== "" ? e : {};
        let scheduleObj = this.$refs.ScheduleObj;
        scheduleObj.eventSettings.query.params[4].value = this.AppointmentLocationVmodel.value;
        scheduleObj.refreshEvents(); 
      },

      isModifiedFields(data) {
        if (this.fieldsToValidate.recurrence === null && data.recurrence) {
          return false
        }
        else if (this.fieldsToValidate.recurrence && data.recurrence === null) {
          return false
        }
        else if (data.recurrence )
          if (data.patientCode !== this.fieldsToValidate.patientCode ||
              data.employeeCode !== this.fieldsToValidate.employeeCode ||
              data.type !== this.fieldsToValidate.appointmentTypeCode ||
              data.startTime.toLocaleTimeString() !== this.fieldsToValidate.startTime.toLocaleTimeString() ||
              data.endTime.toLocaleTimeString() !== this.fieldsToValidate.endTime.toLocaleTimeString()) {
                this.showThisOpt = true
                return true
          }
      },

      onPopupClose: async function(args) {
        if(args.type === 'Editor') {
          if(args.event.target.className.includes("e-event-save")) {
            if (Utils.ValidateDateSchedulerEditor(args.data.startTime,args.data.endTime) === false) {
              args.cancel = true;
              this.showMessage(this.$tc('Msg.Error'),this.$t('schedule_sample.startTimeMsg'),"error");
            }
          } 
        }
      },

      onPopupOpen: async function(args) {
        
        if (args.type === 'EditEventInfo') {
          let titleElement = args.element.querySelector(".e-subject");
          titleElement.innerHTML = args.data.subject;
        }

        let appointmentTypesDataSource = [];
        let admissionsDataSource = [];         
        if ( args.data.recurrence && args.type === 'DeleteAlert') {
            this.applyActionTo = 'ThisEvent'
            args.cancel = true
            this.confirmHeader = this.$t('schedule_sample.deleteAppoReMsg')
            const dialogObj = document.querySelector("#alertDialog").ej2_instances[0];
            var radio = document.querySelector("#radio1").ej2_instances[0];
            radio.checked = true;
            let dlgButtons = dialogObj.getButtons()
            dlgButtons[0].content = this.$t('Shared.Delete')
            this.eventAction = "eventRemove"
            this.eventData = args.data
            this.$emit('load', false);
            dialogObj.show();
        }
      

        async function getAppointmentTypes(employeeCode) { 
        await AppointmentTypes.getAll(employeeCode)
          .then((response) => {
            if(response.status == '200' && response.data && response.data.length > 0){
              appointmentTypesDataSource = response.data;
            }
          })
          .catch(error => {
            if (!error.response) {
            // network error
              this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.RetrieveInformation'),"error");
            } else {
              this.showMessage(this.$tc('Msg.Error'),error,"error");
            }
          });
        }

        async function getPatientRegistrationsScheduler(patientCode) { 
        await ClinicalService.getPatientRegistrationsScheduler(patientCode)
          .then((response) => {
            if(response.status == '200' && response.data && response.data.length > 0){
              admissionsDataSource = response.data;
            }
          })
          .catch(error => {
            if (!error.response) {
            // network error
              this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.RetrieveInformation'),"error");
            } else {
              this.showMessage(this.$tc('Msg.Error'),error,"error");
            }
          });
        }

       
        let scheduleObj = this.$refs.ScheduleObj.ej2Instances;
        let resourceCollections = scheduleObj.getResourceCollections()
        if (args.type === "RecurrenceAlert") {
          args.cancel = true;
          scheduleObj.currentAction= "EditSeries"
          scheduleObj.openEditor(args.data,'EditSeries');
        }  

        if (args.type === 'Editor') {

          this.notifyEmployeeCode = args.data && args.data.employeeCode ? args.data.employeeCode : null
          this.notifyPatientCode = args.data && args.data.patientCode ? args.data.patientCode : null
          this.activityId = args.data && args.data.id ? args.data.id : null

          if (args.data && args.data.patientCode)
            this.$store.commit('setSchEdipatientCode', args.data.patientCode);

          if (args.data && args.data.id)
            this.$store.commit('setSchEdiActivityId', args.data.id);

          if (args.data && args.data.id) {
            let footer = args.element.querySelector('.e-footer-content');
            let btnNotifyElement = document.querySelector('#btnNotify')
            let btnFooterNotifyElement = footer.querySelector('#btnNotify')
            let btnCloseElement = footer.querySelector('.e-event-cancel')

            btnNotifyElement.hidden = false
            
            if (btnFooterNotifyElement)
            footer.removeChild(btnFooterNotifyElement)
          
            footer.insertBefore(btnNotifyElement, btnCloseElement)

            let btnNotify = footer.querySelector('#btnNotify');

            if (btnNotify.classList.contains('e-field')) {
               let btnObject = new Button ({ 
                 content: this.$t('schedule_sample.Notify'),                
               })
               btnObject.appendTo(btnNotify);
            }

            document.getElementById('btnNotify').onclick = () => {
              let btn = document.getElementById('btnNotify')
              let rect = btn.getBoundingClientRect();
              document.getElementById('contextmenunotify').ej2_instances[0].open(rect.y,rect.x)
            };
        } else {
          let footer = args.element.querySelector('.e-footer-content');
          let btnFooterNotifyElement = footer.querySelector('#btnNotify')
          
          if (btnFooterNotifyElement)
            footer.removeChild(btnFooterNotifyElement)
        }
         

          if (args.data && args.data.employeeCode) {
            await getAppointmentTypes(args.data.employeeCode)
          }

          if (args.data && args.data.patientCode) {
            await getPatientRegistrationsScheduler(args.data.patientCode)
          }

          if (!this.useBranchLocations) {
            args.element.querySelector('#branchLocationsDiv').remove();
          } 
          
          let btnCollapsedPatientInfo = args.element.querySelector('#btnCollapsedPatientInfo');
          
          if(args.element.querySelector('#patientCode').value){          
            btnCollapsedPatientInfo.disabled = false;           
          }else{
             btnCollapsedPatientInfo.disabled = true;           
          }

          this.setInitialValues(args.data)
          scheduleObj.eventSettings.query.params[2].value = undefined

          let createdByElement = args.element.querySelector('#createdBy');
          if (createdByElement.classList.contains('createdByClass')) {
            createdByElement.innerHTML = args.data.createdBy;
            if (!args.data.createdBy)
              args.element.querySelector('#createdById').remove();
          }

          let creationDateElement = args.element.querySelector('#creationDate');
          if (creationDateElement.classList.contains('creationDateClass')) {
            creationDateElement.innerHTML = Utils.formatterDateTimeToString(args.data.creationDate);
            if (!args.data.creationDate)
              args.element.querySelector('#creationDateId').remove();
          }

          // Change Editor title
          // args.element.ej2_instances[0].header = `<div class="e-title-text">Appointment Editor ${args.data.patientName}</div>`
          let formElement = args.element.querySelector('.e-schedule-form');
          let subjectElement = args.element.querySelector('#subject');
          if (subjectElement.classList.contains('e-input')) {
              let subjectObject = new TextBox({
                value: args.data.subject,
                change: async function () { 
                        if (typeof (document.getElementById("subject_Error")) != 'undefined' &&
                            document.getElementById("subject_Error")) { 
                              document.getElementById("subject_Error").style.display = "none"; 
                            } 
                           
                           let patientCode = args.element.querySelector('#patientCode').value;
                           let patientShowedUp = args.element.querySelector('#patientShowedUp').ej2_instances[0];
                           let patientConfirmed = args.element.querySelector('#patientConfirmed').ej2_instances[0];
                           let ReasonElement = args.element.querySelector('#reason').ej2_instances[0];

                           if(patientCode){
                             patientShowedUp.disabled = false;
                             patientConfirmed.disabled = false;
                             ReasonElement.enabled = true;

                             let programElement = args.element.querySelector('#admissionRecordId').ej2_instances[0]
                             await getPatientRegistrationsScheduler(patientCode)
                             programElement.dataSource = null
                             programElement.dataSource = admissionsDataSource
                             for (let index = 0; index < admissionsDataSource.length; index++) {
                              const element = admissionsDataSource[index];
                              if (element.status === 'Active') {
                                programElement.index = index
                                break
                              }                            
                             }
                           }
              }
            });
            subjectObject.appendTo(subjectElement);
            subjectElement.setAttribute('name', 'subject');
          }

        let colorElement = args.element.querySelector('#backgroundColor');
        if (colorElement.classList.contains('e-colorpicker')) {            
            let colorPicker = new ColorPicker({
                value: args.data.backgroundColor || '#0A64FF',
                showButtons: false,
                mode: 'Palette',
                modeSwitcher: false,
                change: function(item) {
                    if (item.currentValue) {
                        args.data.backgroundColor = item.currentValue.hex;
                    }
                }
            });
            
            colorPicker.appendTo(colorElement);
            colorElement.setAttribute('name', 'backgroundColor');
  
            document.querySelector('.e-split-colorpicker').onclick = () => {
              colorPicker.toggle();
            }
        }

          let typeElement = args.element.querySelector('#type');
          if (!typeElement.classList.contains('e-dropdownlist')) {
            let dropDownListObject = new DropDownList({
              placeholder: this.$t('schedule_sample.chType'),
              value: args.data.type,
              allowFiltering: true,
              fields: { text: 'description', value: 'code' },
              dataSource: appointmentTypesDataSource,
              change: function (item) { 
                        if (typeof (document.getElementById("type_Error")) != 'undefined' &&
                            document.getElementById("type_Error")) { 
                            document.getElementById("type_Error").style.display = "none"; 
                        }

                        let backgroundColorElement = args.element.querySelector('#backgroundColor').ej2_instances[0]
                        if(item.itemData) {
                          backgroundColorElement.value = item.itemData.backColorForHtml || '#0A64FF'
                          let duration = item.itemData.duration;                          
                         // let startTimeObj = new Date(args.element.querySelector('#startTime').value);
                          let startTimePicker = args.element.querySelector('#startTime').ej2_instances[0]; 
                          let startTimeObj = startTimePicker.value;  
                          let endTimeObj = new Date(startTimeObj.getTime() + duration*60000);
                          let endTime = args.element.querySelector('#endTime').ej2_instances[0];                        
                          endTime.format = Utils.getSchedulerDateTimeFormat();
                          endTime.value = endTimeObj;
                          endTime.dataBind();
                        }
              },
              filtering: function(e) {
                  var query = new Query();
                    query = (e.text != "") ? query.where("description", "contains", e.text, true) : query;
                    e.updateData(appointmentTypesDataSource, query);
              },
            });
            dropDownListObject.appendTo(typeElement);
            typeElement.setAttribute('name', 'type');
          }
          let programElement = args.element.querySelector('#admissionRecordId');
          if (!programElement.classList.contains('e-dropdownlist')) {
            let dropDownListObject = new DropDownList({
              placeholder: this.$tc('Shared.Program',1),
              value: args.data.admissionRecordId,
              allowFiltering: true,
              fields: { text: 'programNameFormated', value: 'recordId' },
              dataSource: admissionsDataSource,
              showClearButton: true,
              change: function () { 
                        if (typeof (document.getElementById("program_Error")) != 'undefined' &&
                            document.getElementById("program_Error")) { 
                              document.getElementById("program_Error").style.display = "none"; 
                            }
              },

              open: function (args) {
                let programel =  args.popup.element.querySelectorAll('.e-list-item');
                for (let index = 0; index < admissionsDataSource.length; index++) {
                  const element = admissionsDataSource[index];
                  if (element.statusBool == false) {
                    programel[index].classList.add('e-hide');
                  }
                }
              },

              filtering: function(e) {
                  var query = new Query();
                    query = (e.text != "") ? query.where("programName", "contains", e.text, true) : query;
                    e.updateData(admissionsDataSource, query);
              },
            });
            dropDownListObject.appendTo(programElement);
            programElement.setAttribute('name', 'admissionRecordId');
          }

          if (this.useBranchLocations) {
            let branchLocationElement = args.element.querySelector('#BranchLocation');
            if (!branchLocationElement.classList.contains('e-dropdownlist')) {
              let dropDownListObject = new DropDownList({
                placeholder: this.$t('schedule_sample.sLocation'),
                value: args.data.branchLocation,
                fields: { text: 'description', value: 'code' },
                dataSource: this.AppointmentLocationList,
                showClearButton: true,
                change: function () { 
                          if (typeof (document.getElementById("BranchLocation_Error")) != 'undefined' &&
                              document.getElementById("BranchLocation_Error")) { 
                              document.getElementById("BranchLocation_Error").style.display = "none"; 
                          }
                },
              });
              dropDownListObject.appendTo(branchLocationElement);
              branchLocationElement.setAttribute('name', 'BranchLocation');
            }
          }

          let ReasonElement = args.element.querySelector('#reason');
          if (!ReasonElement.classList.contains('e-dropdownlist')) {
            let dropDownListObject = new DropDownList({
              value: args.data.reason,
              enabled:args.element.querySelector('#patientCode').value === '' ? false : true,
              fields: { text: 'name', value: 'code' },
              dataSource: this.reasonDataSource,
              change: function (item) {                   
                    let patientShowedUp = args.element.querySelector('#patientShowedUp').ej2_instances[0];
                    let patientConfirmed = args.element.querySelector('#patientConfirmed').ej2_instances[0]
                    let subjectElement = args.element.querySelector('#subject').ej2_instances[0]
                    let typeElement = args.element.querySelector('#type').ej2_instances[0];
                    let backgroundColorElement = args.element.querySelector('#backgroundColor').ej2_instances[0]

                    if(item.itemData) {
                      let subject = new String(subjectElement.value)
                      if (subject.endsWith("- CANCELLED")) {
                        subject = subject.replaceAll(/ - CANCELLED/g, "");
                      } else if (subject.endsWith("- CONFIRMED")) {
                        subject = subject.replaceAll(/ - CONFIRMED/g, "");
                      } else if (subject.endsWith("- SHOWED UP")) {
                        subject = subject.replaceAll(/ - SHOWED UP/g, "");
                      }
                      if (item.itemData.code) {
                        subject = `${subject} - CANCELLED`;
                        patientShowedUp.checked = false
                        backgroundColorElement.value = typeElement.itemData.missedColorForHtml || '#0A64FF'
                      }
                      else if (patientConfirmed.checked && patientShowedUp.checked) {
                        subject = `${subject} - SHOWED UP`;
                        backgroundColorElement.value = typeElement.itemData.checkedColorForHtml || '#0A64FF'
                      } 
                      else if (patientConfirmed.checked) {
                        subject = `${subject} - CONFIRMED`;
                        backgroundColorElement.value = typeElement.itemData.confirmedColorForHtml || '#0A64FF'
                      } 
                      else if (patientShowedUp.checked) {
                        subject = `${subject} - SHOWED UP`;
                        backgroundColorElement.value = typeElement.itemData.checkedColorForHtml || '#0A64FF'
                      } else {
                        backgroundColorElement.value = typeElement.itemData && typeElement.itemData.backColorForHtml ? typeElement.itemData.backColorForHtml :  '#0A64FF'
                      }
                      subjectElement.value = subject
                    }
              },
            });
            dropDownListObject.appendTo(ReasonElement);
            ReasonElement.setAttribute('name', 'Reason');
          }
          let EmployeeElement = args.element.querySelector('#EmployeeCode');
          if (!EmployeeElement.classList.contains('e-dropdownlist')) {
            let dropDownListObject = new DropDownList({
              placeholder: this.$t('schedule_sample.chEmployee'),
              fields: { text: 'employeeName', value: 'employeeCode' },
              value: args.data.employeeCode,
              dataSource:  resourceCollections[0].dataSource,
              change: async function (item) { 
                        if (typeof (document.getElementById("EmployeeCode_Error")) != 'undefined' &&
                            document.getElementById("EmployeeCode_Error")) { 
                              document.getElementById("EmployeeCode_Error").style.display = "none"; 
                            }
                        if(item.itemData && item.itemData.employeeCode) {
                          let typeElement = args.element.querySelector('#type').ej2_instances[0]
                          await getAppointmentTypes(item.itemData.employeeCode)
                          typeElement.dataSource = null
                          typeElement.dataSource = appointmentTypesDataSource
                        }
              }
            });
            dropDownListObject.appendTo(EmployeeElement);
            EmployeeElement.setAttribute('name', 'employeeCode');
          }
          let startElement = args.element.querySelector('#startTime');
          if (!startElement.classList.contains('e-datetimepicker')) {
            new DateTimePicker({
              value: new Date(startElement.value) || new Date(),
              step: 15,
              format:Utils.getSchedulerDateTimeFormat(),
              change: function () { 
                        if (typeof (document.getElementById("startTime_Error")) != 'undefined' &&
                            document.getElementById("startTime_Error")) { 
                              document.getElementById("startTime_Error").style.display = "none"; 
                            }                          
                         // let startTimeObj = new Date(args.element.querySelector('#startTime').value);
                          let startTimePicker = args.element.querySelector('#startTime').ej2_instances[0]; 
                          let startTimeObj = startTimePicker.value; 
                          let typeElementSelected = args.element.querySelector('#type').ej2_instances[0];                        
                          var AppTypeDuration = 15;
                          if(typeElementSelected.itemData)
                            AppTypeDuration = typeElementSelected.itemData.duration;
                          let endTimeObj = new Date(startTimeObj.getTime() + AppTypeDuration*60000);
                          let endTime = args.element.querySelector('#endTime').ej2_instances[0];
                          endTime.value = endTimeObj;
                          endTime.min = startTimeObj  
              },
              locale: this.locale,
            },
              startElement
            );
          }
          let endElement = args.element.querySelector('#endTime');
         // let startTimeObj = new Date(args.element.querySelector('#startTime').value);
         let startTimePicker = args.element.querySelector('#startTime').ej2_instances[0]; 
         let startTimeObj = startTimePicker.value; 
          if (!endElement.classList.contains('e-datetimepicker')) {
            new DateTimePicker({
              value: new Date(endElement.value) || new Date(),
              step: 15,
              min: startTimeObj,
              format:Utils.getSchedulerDateTimeFormat(),
              change: function () { 
                        if (typeof (document.getElementById("endTime_Error")) != 'undefined' &&
                            document.getElementById("endTime_Error")) { 
                              document.getElementById("endTime_Error").style.display = "none"; 
                            } 
              },
              locale: this.locale,
              
          },
           endElement
          );
          }
          let PatientConfirmedElement = args.element.querySelector('#patientConfirmed');
          if (!PatientConfirmedElement.classList.contains('e-checkbox')) {
            new CheckBox(
              { 
                label: this.$t('schedule_sample.pConfirmed'), 
                checked: PatientConfirmedElement.checked,
                disabled:args.element.querySelector('#patientCode').value === '' ? true : false,
                change: function (item) {
                  let subjectElement = args.element.querySelector('#subject').ej2_instances[0]
                  let patientShowedUp = args.element.querySelector('#patientShowedUp').ej2_instances[0]
                  let subject = new String(subjectElement.value)
                  let typeElement = args.element.querySelector('#type').ej2_instances[0];
                  let backgroundColorElement = args.element.querySelector('#backgroundColor').ej2_instances[0]
                  
                  if (subject.endsWith("- CANCELLED")) {
                    subject = subject.replaceAll(/ - CANCELLED/g, "");
                  } else if (subject.endsWith("- CONFIRMED")) {
                    subject = subject.replaceAll(/ - CONFIRMED/g, "");
                  } else if (subject.endsWith("- SHOWED UP")) {
                    subject = subject.replaceAll(/ - SHOWED UP/g, "");
                  }

                  if (item.checked && patientShowedUp.checked) {
                    subject = `${subject} - SHOWED UP`;
                    backgroundColorElement.value = typeElement.itemData.checkedColorForHtml || '#0A64FF'
                  } else if (item.checked) {
                    subject = `${subject} - CONFIRMED`;
                    backgroundColorElement.value = typeElement.itemData.confirmedColorForHtml || '#0A64FF'
                  } else if (patientShowedUp.checked) {
                    subject = `${subject} - SHOWED UP`;
                    backgroundColorElement.value = typeElement.itemData.checkedColorForHtml || '#0A64FF'
                  } else {
                    backgroundColorElement.value = typeElement.itemData.backColorForHtml || '#0A64FF'
                  }
                  subjectElement.value = subject
                 }
              },
              PatientConfirmedElement
            );
          }
          let PatientShowedUpElement = args.element.querySelector('#patientShowedUp');
          if (!PatientShowedUpElement.classList.contains('e-checkbox')) {
            new CheckBox(
              { 
                label: this.$t('schedule_sample.pShowedUp'), 
                checked: PatientShowedUpElement.checked,
                 disabled:args.element.querySelector('#patientCode').value === '' ? true : false,
                change: function (item) {
                  let subjectElement = args.element.querySelector('#subject').ej2_instances[0]
                  let patientConfirmed = args.element.querySelector('#patientConfirmed').ej2_instances[0]
                  let subject = new String(subjectElement.value)
                  let reason = args.element.querySelector('#reason').ej2_instances[0]
                  let typeElement = args.element.querySelector('#type').ej2_instances[0];
                  let backgroundColorElement = args.element.querySelector('#backgroundColor').ej2_instances[0]

                  if (subject.endsWith("- CANCELLED")) {
                    subject = subject.replaceAll(/ - CANCELLED/g, "");
                  } else if (subject.endsWith("- CONFIRMED")) {
                    subject = subject.replaceAll(/ - CONFIRMED/g, "");
                  } else if (subject.endsWith("- SHOWED UP")) {
                    subject = subject.replaceAll(/ - SHOWED UP/g, "");
                  }

                  if (item.checked && patientConfirmed.checked) {
                    subject = `${subject} - SHOWED UP`;
                    reason.value = ''
                    backgroundColorElement.value = typeElement.itemData.checkedColorForHtml || '#0A64FF'
                  } else if (patientConfirmed.checked) {
                    subject = `${subject} - CONFIRMED`;
                    backgroundColorElement.value = typeElement.itemData.confirmedColorForHtml || '#0A64FF'
                  } else if (item.checked) {
                    subject = `${subject} - SHOWED UP`;
                    backgroundColorElement.value = typeElement.itemData.checkedColorForHtml || '#0A64FF'
                    reason.value = '' 
                  }  else {
                    backgroundColorElement.value = typeElement.itemData.backColorForHtml || '#0A64FF'
                  }
                  subjectElement.value = subject
                 }
              },
              PatientShowedUpElement
            );
          }

          let activityIdElement = args.element.querySelector('#activityId');
          if (activityIdElement.classList.contains('e-input')) {
              let activityIdObject = new TextBox({
                value: args.data.id,
            });
            activityIdObject.appendTo(activityIdElement);
            activityIdElement.setAttribute('name', 'activityId');
          }

          let recObj = args.element.querySelector('#RecurrenceEditor').ej2_instances[0]
          this.$refs.ScheduleObj.ej2Instances.eventWindow.recurrenceEditor = recObj;
          if (args.data.recurrence) {
            recObj.setRecurrenceRule(args.data.recurrence);
          }

          document.getElementById('RecurrenceBlock').style.display = (scheduleObj.currentAction == 'EditOccurrence') ? 'none' : 'table-row';
          this.removeNeverOption(args)

          let validator = (formElement).ej2_instances[0]; 
          validator.addRules('type', { required: [true] });
          validator.addRules('subject', { required: [true] });
          validator.addRules('EmployeeCode', { required: [true, 'Employee required!'] });
          if (this.enforceLocation == 'Y') {
            validator.addRules('BranchLocation', { required: [true, 'Location required!'] });
          }
        }
      },

      removeNeverOption(args) {
        let recurElement2 = args.element.querySelector('.e-recurrenceeditor').ej2_instances[0];
        recurElement2.endType.element.ej2_instances[0].listData.splice(0,1)
        let recEndTypeData = recurElement2.endType.element.ej2_instances[0].listData;
        recurElement2.endType.element.ej2_instances[0].element.ej2_instances[0].dataSource = recEndTypeData
      },

      async getCalendarResources() { 
        await CalendarResourcesService.getAll()
          .then((response) => {
            if(response.status == '200' && response.data && response.data.length > 0){
              this.employeeDataSource = response.data;
            }
          })
          .catch(error => {
            if (!error.response) {
            // network error
              this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.RetrieveInformation'),"error");
            } else {
              this.showMessage(this.$tc('Msg.Error'),error,"error");
            }
          });
      },

      branchLocation() {
      if(this.$store.state.branchlocationwasloaded){
            this.AppointmentLocationList = this.$store.state.branchlocationsList;
        }else{
            BranchLocation.GetBranchLocations()
            .then((response) => {
                 if(response.status == '200'){
                  this.AppointmentLocationList = response.data;                     
                  this.$store.commit('initBranchLocationList')
                  this.$store.commit('setBranchLocationwasloaded',true);  
                  response.data.forEach(element => {
                    this.$store.commit('setBranchLocationList',element);
                  });
                 }
          })          
           .catch((error) => {
               if (error.response) {
                 this.showMessage(this.$tc('Msg.Error'),error,"error");
                }
           });   
        } 
      },

      async getProvider(){
      await ProviderService.get(this.$store.state.providerCode)
            .then((response) => {      
               if (response.status == '200' && response.data) { 
                  this.useBranchLocations = response.data.useBranchLocations;
               }  
         })
         .catch(error => { 
          if (!error.response) {                      
                this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.retrieveInfo'),"error");
                    }                      
                    else if(error.response.status === 400 ){
                      this.showMessage(this.$tc('Msg.Error'),error.response.data.errorMessage,"error");
                    } else if(error.response.status === 500){
                        this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.ThereWereSomeError'),"error");
                     } else{
                         this.showMessage(this.$tc('Msg.Error'),error.response.data.errorMessage,"error");
                     }                  
         });
             
    },

      getEventsSettings() {
        let dataManager = new DataManager({
          url: `${ApiService.APIURL}Schedulers/`,
          adaptor: new ScheduleCustomAdaptor(),
          headers: [{
            Authorization: 'Bearer '+ StorageService.getOnlyToken()
          }],
          crossDomain: true,
          crudUrl: `${ApiService.APIURL}Schedulers/crud/`,
        });
        let dataQuery= new Query().addParams('PatientCodeList', undefined);
        dataQuery.addParams('EmployeeCodeList', undefined);
        dataQuery.addParams('applyActionTo', undefined);
        dataQuery.addParams('Status', undefined);
        dataQuery.addParams('BranchLocationList', undefined);
        
        let eventSettings = {
          dataSource:  dataManager,
          query: dataQuery,
          fields: {
            id: 'id',           
            location: {name: 'location' },
            description: {name: 'description' },
            startTime: { name: 'startTime', validation: { required: true } },
            endTime: { name: 'endTime', validation: { required: true } },
            isBlock: 'isBlock',
            recurrence: { name: 'recurrence' },
            backgroundColor: { name: 'backgroundColor' },       
          }
        }           
        return eventSettings
      },

      getValues: function (value) {
        let scheduleObj = this.$refs.ScheduleObj;      
        if(value.code && value.description) {
          this.patientCode = value.code;
          this.patientName = `${value.description} ${value.AuxFields && value.AuxFields[0] ? value.AuxFields[0] : ''}`
        } else {
          this.patientCode = ''
        }
        scheduleObj.eventSettings.query.params[0].value = this.patientCode ? [this.patientCode] : undefined;    

        //if (scheduleObj.eventSettings.query.params[1].value && scheduleObj.eventSettings.query.params[1].value.length > 0) {
        //  let resourcePredicate;
        //  let resourceQuery = resourcePredicate ? new Query().where(resourcePredicate) : new Query(); 
        //  scheduleObj.ej2Instances.resources[0].query = resourceQuery
          //scheduleObj.eventSettings.query.params[1].value = undefined
        //} else {
          //scheduleObj.refreshEvents()
        //}
        
           

        setTimeout(()=>{
          //if(scheduleObj.ej2Instances.eventsData && scheduleObj.ej2Instances.eventsData.length > 0) {
            //let employeeList = []
            //scheduleObj.ej2Instances.eventsData.forEach(element => {
            //  employeeList.push(element.employeeCode)
            //});
            //let uniqueEmployee = [...new Set(employeeList)];
            this.applyFilters(this.employeeValue, this.employeeTypeList)
          //}
        }, 500 );
      },

      getEmployeeTypes() { 
        EmployeeTypesService.getAll()
          .then((response) => {
            if(response.status == '200' && response.data && response.data.length > 0){
              this.employeeTypesDataSource = response.data;
            }
          })
          .catch(error => {
            if (!error.response) {
            // network error
              this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.RetrieveInformation'),"error");
            } else {
              this.showMessage(this.$tc('Msg.Error'),error,"error");
            }
          });
      },

      getCalendarResByEmployeeType(employeeTypes) {
        this.parameter.EmployeeTypeList = employeeTypes
        CalendarResourcesService.getByEmployeeType(this.parameter)
          .then((response) => {
            if(response.status == '200' && response.data && response.data.length > 0){
              response.data.forEach(element => {
                this.employeeTypeList.push(element.employeeCode)
              });
              if (employeeTypes.length > 0)
                this.applyFilters(this.employeeValue, this.employeeTypeList)
              else
                {
                  this.employeeTypeList = []
                  this.applyFilters(this.employeeValue, this.employeeTypeList)
                }
                
            }
          })
          .catch(error => {
            if (!error.response) {
            // network error
              this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.RetrieveInformation'),"error");
            } else {
              this.showMessage(this.$tc('Msg.Error'),error,"error");
            }
          });
      },

      getFacilities() { 
        PatientService.getFacilities('')
          .then((response) => {
            if(response.status == '200' && response.data && response.data.length > 0){
              this.facilityDataSource = response.data;
            }
          })
          .catch(error => {
            if (!error.response) {
            // network error
              this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.RetrieveInformation'),"error");
            } else {
              this.showMessage(this.$tc('Msg.Error'),error,"error");
            }
          });
      },

      getReason() { 
        ReasonService.getAll()
          .then((response) => {
            if(response.status == '200' && response.data && response.data.length > 0){
              this.reasonDataSource = response.data;
              this.reasonDataSource.unshift({active: true,code: "",name: "",reasonType: ""})
              this.$store.commit('setReasonDataSource',this.reasonDataSource);
            }
          })
          .catch(error => {
            if (!error.response) {
            // network error
              this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.RetrieveInformation'),"error");
            } else {
              this.showMessage(this.$tc('Msg.Error'),error,"error");
            }
          });
      },

      onDataBound: function(){        
         if (this.flag) { 
            this.$refs.ScheduleObj.scrollTo(this.$refs.ScheduleObj.ej2Instances.workHours.properties.start);
            this.flag = false; 
          } 
      },

      onCreated: async function(){
        //this.getPermissionLeftMenu(this.Menu,this.$route.path,this.permission); 
        this.getWorkHours()
        await this.getTimeZone()
      },

      getWorkHours(){
       this.$refs.ScheduleObj.ej2Instances.workHours.properties.start = '06:00'
       this.$refs.ScheduleObj.ej2Instances.workHours.properties.end = '20:00'
       
       SchedulerOptionsService.getAll()
       .then((response) => {
       if(response.status == '200' && response.data && response.data.length > 0){
        let schedulerOptions = response.data;            
        if(schedulerOptions[0].dayBegins && schedulerOptions[0].dayEnds) {
          this.$refs.ScheduleObj.ej2Instances.workHours.properties.start = schedulerOptions[0].dayBegins
          this.$refs.ScheduleObj.ej2Instances.workHours.properties.end = schedulerOptions[0].dayEnds
        }
        this.enforceLocation = schedulerOptions[0].enforceLocation
       }
      })
      .catch(error => {     
        /*if(!error.response) {
          this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.NotAbleToInsert'),"error");
        }                      
        else if(error.response.status === 400 ){
          this.showMessage(this.$tc('Msg.Error'),error.response.data.errorMessage,"error");
        }else if(error.response.status === 500){
          this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.ThereWereSomeError'),"error");
        } else{
          this.showMessage(this.$tc('Msg.Error'),error.response.data.errorMessage,"error");
        } */
        this.$emit('load', false);
        this.showResponseErrorMessage(error);
      });
      },

      setUserAssignmentToCalRes(employees){
        let employeeList = []
        employees.forEach(element => {
          employeeList.push(element.employeecode)
        });
        this.changeResources(employeeList)
        this.employeeValue = employeeList
      },

      async getUserAssignmentToCalRes(){
       this.paramsUserAssignment.UserID = StorageService.getUserId();
       await UserAssignmentToCalResService.getAll(this.paramsUserAssignment)
       .then((response) => {
       if(response.status == '200' && response.data && response.data.length > 0){
         this.setUserAssignmentToCalRes(response.data)
         this.isUserAssignmentToCalRes = true
       }
      })
      .catch(error => {
        if (!error.response) {
            // network error
            this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.RetrieveInformation'),"error");
        } else {
            this.showMessage(this.$tc('Msg.Error'),error,"error");
        }
      });
      },

      showReport() {
        this.isReportVisible = true
      },

      closeParamRepWindow() {
        this.isReportVisible = false
      },

      async getTimeZone() { 
         await GlobalService.getTimeZone()
            .then((response) => {      
               if (response.data) {
                this.timezone = response.data.id
                this.tzDisplayName = response.data.displayName
               }  
            })
            .catch(error => {
             if(error.response.status === 400 ){
                 this.showMessage(this.$tc('Msg.Error'),error.response.data.errorMessage,"error");
              }else{
                this.showMessage(this.$tc('Msg.Error'),error,"error");
              }
            });   
      },
  },

  async mounted(){    
    this.OptionsRightMenu.ItemsList = [];
    this.OptionsRightMenu.Mode = false;
    this.OptionsRightMenu.visible = false; 
    this.OptionsRightMenu.btnvisible = false;
    this.$emit('getVisibleMenu', this.OptionsRightMenu);
    this.$emit('getBtnRightMenu', this.OptionsRightMenu);

    /*if(this.permission.length == 0){
        this.$router.push({name: "Main"});    
          setTimeout(() => 
            this.showPermissionMessage()
          , 50); 
        this.$emit('load', false); 
    }*/
    await this.getCalendarResources()
    this.getFacilities()
    this.getReason()
    this.getEmployeeTypes()
    await this.getUserAssignmentToCalRes()
    this.branchLocation()
    this.getProvider()
  },
});
</script>
<style>
    @import '../../../assets/css/syncfusion/bootstrap4.css';
    .schedule-vue-sample .block-events.e-schedule .template-wrap {
        width: 100%;
    }

    .schedule-vue-sample .block-events.e-schedule .e-vertical-view .e-resource-cells {
        height: 58px;
    }

    .schedule-vue-sample .block-events.e-schedule .e-timeline-view .e-resource-left-td,
    .schedule-vue-sample .block-events.e-schedule .e-timeline-month-view .e-resource-left-td {
        width: 170px;
    }

    .schedule-vue-sample .block-events.e-schedule .e-resource-cells.e-child-node .employee-category,
    .schedule-vue-sample .block-events.e-schedule .e-resource-cells.e-child-node .employee-name {
        padding: 5px
    }

    .schedule-vue-sample .block-events.e-schedule .employee-image {
        width: 45px;
        height: 40px;
        float: left;
        border-radius: 50%;
        margin-right: 10px;
    }

    .schedule-vue-sample .block-events.e-schedule .employee-name {
        font-size: 13px;
    }

    .schedule-vue-sample .block-events.e-schedule .employee-designation {
        font-size: 10px;
    }

    .schedule-vue-sample .content-wrapper{
      padding: 0 !important;
    }    

    .schedule-vue-sample .e-day-view .e-date-header-wrap table col, .e-schedule .e-day-view .e-content-wrap table col { 
      width: 200px; 
    }
    .eventHintHeader{
      padding-bottom: 3px;
      border-bottom: 1px solid silver;
    }
    .eventHint{
      text-align: left;
      padding: 0 6px 6px 6px;
      color: seashell;
      vertical-align: bottom;
    }
    .eventHint svg{
      color: white;
      margin: 10px 4px 0 0;
    }
    .e-footer-content button{
      text-transform: uppercase !important;
    }
    .e-schedule .e-vertical-view .e-time-cells-wrap table td, .e-schedule .e-vertical-view .e-work-cells {
      height: 30px !important;
    }

    .e-refresh-icon::before {
      content: '\e716';
      font-weight:bold
    }

    .e-print-icon::before {
      content: '\e743';
      font-weight:bold
    }

    @media screen and (max-width: 600px) {
      .HideFilter{
        display:none;
      }
    }

    .panel-scheduler {
      box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important;
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      background-image: -webkit-linear-gradient(268deg, #FAFAFA, #FAFAFAEE);
      border-radius: 0 0 14px 14px;
      border-top: 1px solid #EEE;
      padding: 10px 10px 10px 15px;
      text-align: left;
      z-index: 2;
    }

    .e-hide { 
      opacity:0.7; 
      pointer-events:none; 
    } 

</style>